<template>
  <div class="container">
    <NavigationBar/>
    <HomePrimaryHero/>
    <div class="mt-5" style="margin-bottom: 5rem;" v-if="locale === 'bg'">
      <NewsCarousel/>
    </div>
    <div class="title mt-5">{{ $t('unique-heading') }}</div>
    <UncertantyComponent/>
    <StatisticsComponent/>
    <OfferingComponent/>
  </div>
  <InfoPointsComponent/>
  <HomeTestimonialsComponent/>
  <HomeSignUpComponent/>
  <OrganizationExamplesComponent/>
  <div class="container pb-5">
    <div class="title mt-5 mb-5">{{ $t('benefits-heading') }}</div>
    <BenefitsComponent/>
  </div>
  <UniqueComponent/>
  <FooterComponent/>
</template>

<script setup>
import {useI18n} from 'vue-i18n';
import NavigationBar from '@/components/NavigationBar.vue';
import HomePrimaryHero from '@/components/Components/Home/HomePrimaryHero.vue';
import UncertantyComponent from '@/components/Components/UncertantyComponent.vue';
import StatisticsComponent from '@/components/Components/StatisticsComponent.vue';
import OfferingComponent from '@/components/Components/OfferingComponent.vue';
import InfoPointsComponent from '@/components/Components/InfoPointsComponent.vue';
import HomeTestimonialsComponent from '@/components/Components/Home/HomeTestimonialsComponent.vue';
import HomeSignUpComponent from '@/components/Components/Home/HomeSignUpComponent.vue';
import OrganizationExamplesComponent from '@/components/Components/Home/OrganizationExamplesComponent.vue';
import BenefitsComponent from '@/components/Components/BenefitsComponent.vue';
import UniqueComponent from '@/components/Components/UniqueComponent.vue';
import FooterComponent from '@/components/Components/FooterComponent.vue';
import NewsCarousel from "@/components/Components/Home/NewsCarousel.vue";

const {locale} = useI18n();
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/fonts.scss";

.title {
  font-size: 25px;
  font-weight: 400;
  line-height: 1;
  color: #6B6B9C;
  text-align: center;
}

@media (max-width: 768px) {
  .title {
    font-size: 20px;
    padding-left: 12px;
    padding-right: 12px;
  }
  .container {
    padding-left: 12px;
    padding-right: 12px;
    max-width: 100%;
    overflow-x: hidden;
  }
  .mt-5 {
    margin-bottom: 3rem !important;
  }
}
</style>